import { useState, useEffect } from 'react';
import { getProductDropSalesQuantity } from '../api/storefront/product';
import { getProductIDFromShopifyGID } from '../utils/product';

export const useFetchSalesQuantityForProductDrop = (
  productDropCollection: Shopify.Collection | null,
  currentProductDropSalesQuantity: number,
) => {
  const [productDropSalesQuantity, setProductDropSalesQuantity] = useState<number | null>(
    currentProductDropSalesQuantity,
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setProductDropSalesQuantity(currentProductDropSalesQuantity);
  }, [currentProductDropSalesQuantity]);

  useEffect(() => {
    if (!productDropCollection) {
      setProductDropSalesQuantity(null);
      setIsLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const productIdsJoined = productDropCollection.products.edges
          .map((productEdge: Shopify.ProductEdge) => getProductIDFromShopifyGID(productEdge.node.id))
          .join(',');

        const productDropSalesQuantity = await getProductDropSalesQuantity(productIdsJoined)
          .then((response) => response.data)
          .catch(() => null);

        if (productDropSalesQuantity === null) {
          setProductDropSalesQuantity(null);
          setIsLoading(false);
          return;
        }

        setProductDropSalesQuantity(productDropSalesQuantity.quantity);
        setIsLoading(false);
      } catch (_) {
        setProductDropSalesQuantity(null);
        setIsLoading(false);
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 10_000);

    return () => clearInterval(intervalId);
  }, [productDropCollection]);

  return { productDropSalesQuantity, isLoading };
};
